import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { ZoneRestService } from "@app/services/hal/zone-rest.service";
import { Zone } from "@app/models/rest/zone";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class ZoneStore extends RealTimeDataStore<Zone> {
  constructor() {
    const zoneRestService = inject(ZoneRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(zoneRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Zone");
  }
}
